import React, { useCallback, useEffect, useRef, useState } from "react";
import { X } from "lucide-react";

export function useAdminNotice(timeoutMs = 4200) {
  const [notice, setNotice] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const clearNotice = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setNotice(null);
  }, []);

  const showNotice = useCallback((type, title, message) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setNotice({ type, title, message });
    timerRef.current = setTimeout(() => setNotice(null), timeoutMs);
  }, [timeoutMs]);

  return { notice, showNotice, clearNotice };
}

export function AdminNotice({ notice, onClose }) {
  if (!notice) return null;
  return (
    <div style={{ ...noticeToast, ...(noticeTone[notice.type] || noticeTone.info) }} role="status">
      <div>
        <strong style={noticeTitle}>{notice.title}</strong>
        <div style={noticeText}>{notice.message}</div>
      </div>
      <button type="button" style={noticeClose} onClick={onClose}>
        <X size={16} />
      </button>
    </div>
  );
}

const noticeToast = {
  position: "fixed",
  top: "84px",
  right: "22px",
  width: "min(420px, calc(100vw - 28px))",
  zIndex: 1300,
  borderRadius: "16px",
  padding: "14px 15px",
  boxShadow: "0 22px 50px rgba(15,23,42,0.20)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "14px",
};

const noticeTone = {
  success: { background: "#ecfdf5", border: "1px solid #86efac", color: "#14532d" },
  error: { background: "#fef2f2", border: "1px solid #fecaca", color: "#7f1d1d" },
  info: { background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1e3a8a" },
};

const noticeTitle = { display: "block", fontSize: "14px", fontWeight: 900 };
const noticeText = { marginTop: "5px", fontSize: "13px", lineHeight: 1.35, fontWeight: 700 };
const noticeClose = {
  width: "28px",
  height: "28px",
  border: 0,
  borderRadius: "999px",
  background: "rgba(15,23,42,0.08)",
  color: "inherit",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
  flex: "0 0 auto",
};
